export enum OwnerType {
  INDIVIDUAL = "INDIVIDUAL",
  LEGAL_ENTITY = "LEGAL_ENTITY",
}
